import type { BrandTheme, PartialBrandTheme } from '../../types/BrandTheme'
import { brandTheme } from '../../types/BrandTheme'
import { merge } from 'theme-ui'
import { dirname } from 'path'
import {
  resolveFontFamily,
  resolveThemeUIFontSizes,
} from '@jotta/ui/FontConfig'

import './theme.css'

export const obostheme: BrandTheme = merge.all<BrandTheme, PartialBrandTheme>(
  brandTheme,
  {
    branding: {
      brand: 'OBOS',
      themedir: dirname(new URL(import.meta.url).pathname),
      staticDir: 'obos',
      height: 37,
      header: {
        showSignupButtons: false,
        showHamburger: false,
      },
      showLanguageSelector: false,
    },
    space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
    radii: [0, 2, 4, 8],
    fontSizes: resolveThemeUIFontSizes('obos'),
    fonts: resolveFontFamily('obos'),
    fontWeights: {
      body: 400,
      heading: 700,
      bold: 700,
    },
    lineHeights: {
      body: 1.5,
      heading: 1.125,
    },
    colors: {
      text: '#444',
      background: '#fff',
      primary: '#0D4FA7',
      secondary: '#00AA79',
      focus: '#0D4FA7',
      focusDark: '#fff',
      muted: '#f6f6f6',
      border: '#eaeaea',
    },
    buttons: {
      primary: {
        color: 'white',
        backgroundColor: 'secondary',
        borderRadius: 4,
      },
      secondary: {
        variant: 'buttons.primary',
        color: 'text',
        background: 'white',
        borderColor: 'border',
      },
    },
    forms: {
      checkbox: {
        borderRadius: '2px',
      },
    },
    styles: {
      fileIcon: {
        '--file-icon-border-color': 'rgb(160, 197, 240)',
        '--file-icon-symbol-color': 'rgba(160, 197, 240, 0.7)',
        '--folder-icon-border-color': 'rgb(160, 197, 240)',
        '--folder-icon-fill': 'rgb(160, 197, 240, 0.3)',
        '[data-svg^="folder"]': {
          strokeWidth: 1.5,
          strokeOpacity: 1,
        },
        '[data-svg^="file"]': {
          strokeWidth: 1.5,
          strokeOpacity: 1,
        },
      },
    },
  },
)
export default obostheme
